









































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import SelectableEntity from '@/models/Shared/SelectableEntity';
import BookingRoleWorkerShiftDto from '@/models/BookingRoleWorkerShifts/BookingRoleWorkerShiftDto';
import BookingRoleWorkerShiftStatusEnum from '@/models/BookingRoleWorkerShifts/BookingRoleWorkerShiftStatus';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
// @ts-ignore
import VCurrencyField from 'v-currency-field';
import { component } from 'vue/types/umd';

@Component({
    name: 'BookingManageWorkersResendConfirmation', 
    components: {  }
})
export default class extends GiganautVueDialog {
  
  public dialog = false;
  public awaitingConfirmation = false;

	bookingRoleWorkerShiftStatusEnum = BookingRoleWorkerShiftStatusEnum;
  
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      const unconfirmedShifts = BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker.bookingRoleWorkerShifts.filter(function(bookingRoleWorkerShift){
        if (bookingRoleWorkerShift.status === BookingRoleWorkerShiftStatusEnum.BookedUnconfirmed ) {
          return true;
        }
        return false;
      })
      if (unconfirmedShifts.length === 0) {
        this.awaitingConfirmation = false;
      } 
      else {
        this.awaitingConfirmation = true;
        await BookingDetailsModule.getBookingRoleWorkerConfirmationUrl(BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker.id)
      }
    } else {
      BookingDetailsModule.offeredWorkersVM.confirmationUrl = "";
    }
  }

  get url() {
    return BookingDetailsModule.offeredWorkersVM.confirmationUrl;
  }

  get loading() {
    return BookingDetailsModule.loadingDialog;
  }

  get selectedWorker() {
      return BookingDetailsModule.offeredWorkersVM.selectedWorker;
  }
}
